import { axiosHttp } from "@/util/axios.js";

// 用户行为监听
export function addRecord(data) {
  return axiosHttp.$postAxios("/access/addRecord", data);
}



// WEBPACK FOOTER //
// ./src/apis/addRecord.js